import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const InviteSchema = withDefaults({
  type: 'invite',
  objectExtensions: ['invite'],
  fields: [
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'enrollmentLink',
    },
    {
      kind: 'attribute',
      name: 'fromDate',
    },
    {
      kind: 'attribute',
      name: 'expirationDate',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default InviteSchema;
